module.exports = __webpack_public_path__ + "img/layers-2.401bc33e.svg";